<template>
  <div id="app">
    <div v-if="quoteIsLoaded">
      <header>
        <div class="masthead">
          <div class="ui grid">
            <div class="ten wide column">
              <h1 class="ui header">
                <div class="sub header">
                  <strong>{{ quoteMeta.job_no }}</strong>
                  |
                  Version: {{ quoteMeta.version }}
                </div>
                {{ quoteMeta.title }}
                <div class="sub header">
                  {{ quoteMeta.customer }}
                </div>
              </h1>
            </div>
            <div class="six wide right aligned column">
              <div class="ui tiny grey statistic">
                <div class="value">
                  {{ quoteAggregates.hours }}
                </div>
                <div class="label">
                  Hours
                </div>
              </div>
              <div class="ui tiny grey statistic">
                <div class="value">
                  +
                </div>
              </div>
              <div class="ui tiny grey statistic">
                <div class="value">
                  {{ quoteAggregates.pm }}
                </div>
                <div class="label">
                  PM
                </div>
              </div>
              <div class="ui tiny grey statistic">
                <div class="value">
                  =
                </div>
              </div>
              <div class="ui tiny statistic">
                <div class="value">
                  {{ quoteAggregates.total_hours }}
                </div>
                <div class="label">
                  Total
                </div>
              </div>
            </div>
          </div>
          <div class="ui dimmer">
            <div class="content">
              <div class="center">
                <div v-bind:class="flash.type" class="ui message">
                  <i @click="clearFlash" class="close icon"></i>
                  <div class="header">
                    {{ flash.type | capitalize }}
                  </div>
                  <p>{{ flash.message }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui top menu">
          <router-link :to="{ name: 'dashboard' }" class="item">Dashboard</router-link>
          <router-link :to="{ name: 'summary' }" v-if="quoteIsLoaded" class="item">Summary</router-link>
          <router-link :to="{ name: 'editor' }" v-if="quoteIsLoaded" class="item">Editor</router-link>
          <router-link :to="{ name: 'fixed_cost_items' }" v-if="quoteIsLoaded" class="item">Fixed Cost Items</router-link>
          <div v-if="quoteIsLoaded" class="ui right menu">
            <div class="item darken-on-hover">
              Last saved: {{ quoteLastSaved }}
            </div>
            <a v-if="quoteHasBeenEdited" @click.prevent="saveQuote" href="#" class="item save-quote">Save</a>
            <div v-else class="item save-quote">Saved</div>
            <div id="save-new-version" class="ui dropdown item">
              <i class="dropdown icon"></i>
              <div class="menu">
                <div class="link item" @click="saveNewQuoteVersion">Save New Version</div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    quoteAggregates () {
      return this.$store.getters.aggregates
    },

    quoteIsLoaded () {
      return this.$store.getters.quoteIsLoaded
    },

    quoteLastSaved () {
      return this.$store.getters.quoteLastSaved
    },

    quoteHasBeenEdited () {
      return this.$store.getters.quoteHasBeenEdited
    },

    quoteMeta () {
      return this.$store.getters.meta
    },

    flash () {
      return this.$store.getters.flash
    },

    flashIsActive () {
      return this.$store.getters.flashIsActive
    }
  },

  watch: {
    flashIsActive () {
      if (this.flashIsActive) {
        window.$('header .masthead .dimmer').dimmer({ closable: false }).dimmer('show')
      } else {
        window.$('header .masthead .dimmer').dimmer('hide')
      }
    }
  },

  methods: {
    saveQuote () {
      this.$store.dispatch('saveQuote')
    },

    saveNewQuoteVersion () {
      this.$store.dispatch('saveNewQuoteVersion')
    },

    clearFlash () {
      this.$store.commit('CLEAR_FLASH')
    }
  },

  mounted () {
    window.$('#save-new-version').dropdown({ on: 'hover', action: 'hide' })
  },

  updated () {
    window.$('#save-new-version').dropdown({ on: 'hover', action: 'hide' })
  }
}
</script>

<style lang="scss">
  body, html {
    height: auto;
  }

  header {
    position: fixed;
    z-index: 101;
    width: 100%;
    top: 0;
    left: 0;
    right: auto;
    bottom: auto;

    .masthead {
      padding: 1em;
      background-color: #fff;

      .sub.header strong {
        color: #2185D0;
      }
    }

    .ui.menu {
      border-left: none;
      border-right: none;
      border-radius: 0 !important;
      margin-top: 0;

      .item > i.dropdown.icon {
        margin: 0;
      }
    }

    .ui.right.menu {
      border-top: none;
      border-bottom: none;

      div.item {
        color: #bbb;

        &.darken-on-hover:hover {
          color: darken(#bbb, 30%);
        }
      }

      a.item {
        background-color: #FF851B;
        color: #fff;
        border-radius: 0;

        &:hover {
          background-color: #F2711C;
        }
      }
    }
  }

  .view {
    margin-top: 160px;
    margin-bottom: 3em;
  }

  .ui.dimmer {
    .message {
      margin: 0 auto;
      text-align: left;
      min-width: 400px;
      width: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?36d2a2ba